SWR.Social.prototype._loadGiphy = function _loadGiphy(){
  var self = this;

  try {
    var giphyId;
    var regex = new RegExp("https?:\/\/(media|i\.giphy\.com\/media\/([^ /\n]+)\/(?:([^ /\n]+)\/)?(?:giphy|source([^ \/\n]+)?\.gif|mp4)|i\.giphy.com\/([^ /\n]+)\.gif|giphy\.com\/gifs\/(?:.*-)?([^ /\n]+))", "gm");
    var matches = regex.exec(self.url);

    do {
      giphyId = matches.pop();
    } while ('undefined' === typeof giphyId)

    var html = COMMON.Utils.template(
      '<div class="embed-responsive embed-responsive-1by1">' +
      '<iframe src="https://giphy.com/embed/{giphyId}" loading="lazy" width="100%" height="100%" style="position:absolute" class="embed-responsive-item giphy-embed" allowFullScreen></iframe>' +
      '</div>', {
      'giphyId': giphyId
    });

    self._done(html);
  } catch (e) {
    self._failed(self.config.embedCookie, self.url);
  }
};
